import qs from 'query-string'
import { useLocation, useNavigate } from 'react-router-dom'
import { Radio, RadioChangeEvent } from 'antd'
import {
    PDF_VIEWER_QUERY_PARAM,
    THREE_D_VIEWER_QUERY_PARAM,
    VIEWER_QUERY_PARAM,
} from '@Admin/AdminQuotingPage/constants'

import Box from '~/core/Box'
import { useExtractUrlSearchParams } from '~/lib/extractUrlSearchParams'

import styles from './styles.css'

const THREE_D_RADIO_VALUE = '3d'
const TWO_D_RADIO_VALUE = '2d'

const RADIO_STYLE = { padding: '1px 8px' }

const Toggle3dAnd2dView = () => {
    const navigate = useNavigate()
    const { search } = useLocation()

    const searchParams = useExtractUrlSearchParams(search, [VIEWER_QUERY_PARAM])

    const viewerMode = searchParams[VIEWER_QUERY_PARAM]

    const radioButtonDefaultValue =
        viewerMode === THREE_D_VIEWER_QUERY_PARAM
            ? THREE_D_RADIO_VALUE
            : TWO_D_RADIO_VALUE

    const onDfmSelection = (evt: RadioChangeEvent) => {
        const selectedMode = evt.target.value
        const currentQueryParams = qs.parse(search)

        const newQueryParams = {
            ...currentQueryParams,
        }

        newQueryParams[VIEWER_QUERY_PARAM] =
            selectedMode === THREE_D_RADIO_VALUE
                ? THREE_D_VIEWER_QUERY_PARAM
                : PDF_VIEWER_QUERY_PARAM

        navigate(
            {
                search: qs.stringify(newQueryParams),
            },
            { replace: true },
        )
    }

    return (
        <Box direction="col">
            <Radio.Group
                buttonStyle="outline"
                className={styles.radioButtons}
                defaultValue={radioButtonDefaultValue}
                key="dfm-mode"
                onChange={onDfmSelection}
                size="small"
                value={radioButtonDefaultValue}
            >
                <Radio.Button style={RADIO_STYLE} value={THREE_D_RADIO_VALUE}>
                    3D DFM
                </Radio.Button>
                <Radio.Button style={RADIO_STYLE} value={TWO_D_RADIO_VALUE}>
                    2D DFM
                </Radio.Button>
            </Radio.Group>
        </Box>
    )
}

export default Toggle3dAnd2dView
